var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11C13.5313 11 15.5833 8.94801 15.5833 6.41671C15.5833 3.8854 13.5313 1.83337 11 1.83337C8.46865 1.83337 6.41663 3.8854 6.41663 6.41671C6.41663 8.94801 8.46865 11 11 11Z",
    stroke: "#585858",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 12.8334H15.906C16.5761 12.8336 17.2232 13.0785 17.7255 13.522C18.2278 13.9656 18.5509 14.5774 18.634 15.2424L18.9924 18.106C19.0246 18.364 19.0016 18.6259 18.9249 18.8743C18.8482 19.1227 18.7195 19.352 18.5475 19.5469C18.3754 19.7417 18.1638 19.8978 17.9268 20.0047C17.6898 20.1115 17.4328 20.1668 17.1728 20.1667H4.82714C4.56716 20.1668 4.31014 20.1115 4.07313 20.0047C3.83613 19.8978 3.62457 19.7417 3.45249 19.5469C3.2804 19.352 3.15174 19.1227 3.07503 18.8743C2.99832 18.6259 2.97532 18.364 3.00756 18.106L3.36506 15.2424C3.4482 14.5771 3.77152 13.9651 4.27424 13.5214C4.77695 13.0778 5.42442 12.8331 6.09489 12.8334H6.41664",
    stroke: "#585858",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/personIcon.3d73fc5a3505c4bd7513f8ae932ee647.svg";
export { ForwardRef as ReactComponent };